<template>
  <div class="w100 Overview">
    <div class="search-top" v-loading="Loading">
      <!-- <el-input
          style="width: 300px"
          clearable
          v-model="searchData.SupplierName"
          placeholder="请输入供应商名称"
        ></el-input> -->
      <div>
        <el-select
          v-model="searchData.SupplierId"
          filterable
          clearable
          style="width: 260px"
          placeholder="请选择供应商"
        >
          <el-option
            v-for="item in SupplierData"
            :key="item.Id"
            :label="item.title"
            :value="item.Id"
          ></el-option>
        </el-select>
        <el-input
          style="width: 260px; margin-left: 10px"
          v-model="searchData.Device"
          clearable
          placeholder="请输入设备名称/编号"
        ></el-input>
        <el-input
          style="width: 260px; margin-left: 10px"
          v-model="searchData.Accessory"
          clearable
          placeholder="请输入配件名称/编号"
        ></el-input>
        <el-button type="primary" style="margin-left: 10px" @click="getDataList"
          >查询</el-button
        >
      </div>
      <!-- <div style="">
        <span class="Quantity">配件数量小计：{{ TotalQuantity }}</span>
        <span class="Quantity">配件数量总计：{{ SumQuantity }}</span>
      </div> -->
    </div>
    <el-table
      class="table-ove"
      :data="Data"
      style="width: 100%"
      header-row-class-name="table-tit"
      v-loading="Loading"
    >
      <el-table-column
        type="index"
        label="序号"
        width="55"
        align="center"
      ></el-table-column>

      <el-table-column prop="DeviceCode" label="设备编号" align="center" />
      <el-table-column prop="DeviceName" label="设备名称" align="center" />

      <el-table-column prop="AccessoryCode" label="配件编号" align="center" />
      <el-table-column prop="AccessoryName" label="配件名称" align="center" />
      <el-table-column prop="TypeName" label="配件类型" align="center" />
      <el-table-column prop="AccessorySpec" label="配件规格" align="center" />
      <el-table-column
        prop="AccessoryNum"
        label="配件数量"
        align="right"
        width="100"
      />
      <el-table-column prop="SupplierName" label="供应商名称" align="center" />
      <el-table-column prop="Supplier" label="生产厂家名称" align="center" />
    </el-table>
  </div>
</template>
<script>
import * as echarts from 'echarts'

export default {
  data() {
    return {
      Loading: false,
      Data: [],
      searchData: {
        Device: '',
        Accessory: '',
        SupplierId: '',
      },
      TotalQuantity: '',
      SumQuantity: '',
      SupplierData: [],
    }
  },
  props: {
    pId: {
      type: String,
      default: '',
    },
  },
  components: {},
  methods: {
    getSupplierData() {
      this.$http
        .post(
          `/Base_ProjectWork/Base_ProjectSupplier/GetProjectSupplierTree?ProjectId=${this.pId}&Type=0`
        )
        .then((res) => {
          if (res.Success) {
            this.SupplierData = res.Data
          }
        })
    },
    rowName(obj) {
      if (obj.row.Leve == 1) {
        return 'level1'
      }
    },
    getDataList() {
      this.Loading = true
      this.$http
        .post(`/Base_ProjectWork/Base_Project/GetDeviceAccessoryList`, {
          Search: {
            ProjectId: this.pId,
            ...this.searchData,
          },
        })
        .then((res) => {
          this.Loading = false
          if (res.Success) {
            this.Data = res.Data?.Data || []
          }
        })
    },

    createGaugeChart(containerId, value, color) {
      const container = document.getElementById(containerId)
      if (!container) return

      const chart = echarts.init(container)
      const option = {
        series: [
          {
            type: 'gauge',

            min: 0,
            max: 100,
            //分割数
            splitNumber: 5,
            radius: '90%',
            center: ['50%', '50%'],
            progress: {
              show: true,
              width: 6,
              itemStyle: {
                color: color,
              },
              roundCap: true,
            },
            axisLine: {
              lineStyle: {
                width: 6,
              },
            },
            // 刻度样式。
            axisTick: {
              show: true,
              distance: 1,
              length: 1,
              lineStyle: {
                width: 1,
                color: '#999',
              },
            },
            splitLine: {
              distance: 1,
              show: true,
              length: 0,
              lineStyle: {
                width: 1,
                color: '#999',
              },
            },
            axisLabel: {
              distance: 7,
              color: '#999',
              fontSize: 8,
            },
            pointer: {
              width: 3,
              length: '70%',
              itemStyle: {
                color: color,
              },
            },
            detail: {
              formatter: '{value}%',
              textStyle: {
                fontSize: 12,
                color: '#333',
              },
              offsetCenter: [0, 12],
            },
            data: [
              {
                value: value || 0,
              },
            ],
          },
        ],
      }

      chart.setOption(option)
      chart.resize()
    },
  },
  mounted() {
    // this.initCharts()
  },
  created() {
    this.getSupplierData()
    this.getDataList()
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .table-tit {
  font-weight: 1000;
  font-size: 16px;
  color: #000;
  height: 40px;
}
.table-ove {
  margin-bottom: 20px;
}
.Overview {
  padding: 0 10px;
}
::v-deep .el-table__body-wrapper {
  .el-table__cell {
    font-size: 14px;
  }
}
::v-deep .level1 {
  font-size: 14px;
  color: #000;
  font-weight: bold;
}
</style>
